<script setup lang="ts">
import { useDarkTheme } from '@/shared/lib/composables';

useDarkTheme();
</script>

<template>
  <div class="min-h-dvh bg-(--base-main-bg) text-(--base-text-color)">
    <slot name="header" />

    <main class="mx-auto w-full max-w-[1600px] px-4 py-5 sm:px-6 sm:py-7 xl:px-8">
      <slot />
    </main>

    <slot name="overlay" />
  </div>
</template>
